/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gain (+500)`)
};

const es_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganar (+500)`)
};

const de_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zunehmen (+500)`)
};

const nl_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankomen (+500)`)
};

const fr_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prise (+500)`)
};

const it_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentare (+500)`)
};

const pt_br2_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhar (+500)`)
};

const pt_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhar (+500)`)
};

const ja_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`増量 (+500)`)
};

const zh_bmr_gain = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`增重（+500）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_gain = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_gain(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_gain", locale)
	if (locale === "en") return en_bmr_gain(inputs)
	if (locale === "es") return es_bmr_gain(inputs)
	if (locale === "de") return de_bmr_gain(inputs)
	if (locale === "nl") return nl_bmr_gain(inputs)
	if (locale === "fr") return fr_bmr_gain(inputs)
	if (locale === "it") return it_bmr_gain(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_gain(inputs)
	if (locale === "pt") return pt_bmr_gain(inputs)
	if (locale === "ja") return ja_bmr_gain(inputs)
	return zh_bmr_gain(inputs)
};